<span class="input-postfix-data">
  {{data}}
</span>
